import { loadStripe } from "@stripe/stripe-js";
export const API_URL = import.meta.env.VITE_API_URL ;


export const PLATFORM_FEE_PERCENT = 0.10;
export const TAX_PERCENT = 0;

export const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
);
